import { render, staticRenderFns } from "./AdminClicks.vue?vue&type=template&id=ceb837c6&scoped=true&"
import script from "./AdminClicks.vue?vue&type=script&lang=js&"
export * from "./AdminClicks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb837c6",
  null
  
)

export default component.exports